import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';

/* 라우트 */
import Fsearch from './routes/Fsearch';
import DetailPage from './routes/DetailPage';
import Ai from './routes/Ai';
import Experience from './routes/Experience';
import Experience01 from './routes/Experience01';
import Reservation from './routes/Reservation';
import Main from './routes/Main';
import Login from './routes/Login';

/* 컴포넌트 */
import Splash from './components/Splash';

function App() {

  return (
    <div className="App">
      {/* 헤더 */}
      {/* <Header /> */}
      {/* 컨텐츠 */}
      <Routes>
        <Route path='/' element={
          <>
            <Splash/>
          </>
        } />
        <Route path='/Fsearch' element={<Fsearch />} />
        <Route path='/DetailPage' element={<DetailPage />} />
        <Route path='/Ai' element={<Ai />} />
        <Route path='/Experience' element={<Experience />} />
        <Route path='/Experience01' element={<Experience01 />} />
        <Route path='/Reservation' element={<Reservation />} />
        <Route path='/Main' element={<Main />} />
        <Route path='/Login' element={<Login />} />
      </Routes>
      {/* 푸터 */}
      {/* <Footer /> */}
    </div>
  );
}

export default App;
